module.exports = __webpack_public_path__ + "img/img05.c4c6cae4.jpeg";